import {
    getAddressForPointAction,
    getInstructionsForAction,
    normalizeRoutePointAction,
} from '../Rotas/routePointAction';
import {
    getCustomerIdFromRoutePoint,
    getPointDeliveryDetails,
    mapRouteDeliveryToPlanningShape,
} from '../../services/routeService';

/**
 * Normaliza um ponto da API para o formato consumido pelas telas do motorista.
 * @param {object} point
 * @returns {object}
 */
export function mapDriverPontoForView(point) {
    const deliveryDetails = getPointDeliveryDetails(point);
    const deliveryShape = mapRouteDeliveryToPlanningShape(deliveryDetails);
    const action = normalizeRoutePointAction(
        typeof point.targetAction === 'object'
            ? point.targetAction?.value
            : point.targetAction ?? point.action,
    );
    const { address: fullAddress } = deliveryShape
        ? getAddressForPointAction(action, deliveryShape)
        : { address: '—' };
    const deliveryInstructions = getInstructionsForAction(action, deliveryShape);
    const items = Array.isArray(deliveryShape?.items)
        ? deliveryShape.items.map((item) => ({
              qty: item.quantity ?? item.qty ?? 0,
              description: item.description || '—',
          }))
        : [];

    return {
        id: point.id,
        index: point.index ?? 0,
        action,
        fullAddress,
        deliveryInstructions,
        observation: (point.description ?? '').trim(),
        state: point.state,
        items,
        driverComment: (point.driverComment ?? '').trim(),
        photos: Array.isArray(point.photos) ? point.photos : [],
        deliveryId: deliveryDetails?.id ?? null,
        customerId: getCustomerIdFromRoutePoint(point) ?? deliveryShape?.customerId ?? null,
        customerName: deliveryShape?.customerName ?? null,
        customerType: deliveryShape?.customerType ?? null,
    };
}

/**
 * Normaliza o detalhe de roteiro da API para a jornada do motorista.
 * @param {object|null|undefined} apiRoute
 * @returns {object|null}
 */
export function mapDriverRouteForView(apiRoute) {
    if (!apiRoute || apiRoute.id == null) return null;

    const rawPoints = Array.isArray(apiRoute.points) ? apiRoute.points : [];
    const sortedPoints = [...rawPoints].sort(
        (a, b) => (a.index ?? 0) - (b.index ?? 0),
    );

    return {
        id: apiRoute.id,
        alias: apiRoute.alias || `Roteiro #${apiRoute.id}`,
        state: apiRoute.state,
        driverId: apiRoute.driverId ?? null,
        driverName: apiRoute.driverName || '—',
        creationDateTime: apiRoute.creationDateTime ?? null,
        lastUpdateDateTime: apiRoute.lastUpdateDateTime ?? null,
        pointCount: apiRoute.pointCount ?? sortedPoints.length,
        points: sortedPoints.map(mapDriverPontoForView),
    };
}
